export default IconStretching2 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-stretching-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M11 4a1 1 0 1 0 2 0a1 1 0 0 0 -2 0" />
  <path d="M6.5 21l3.5 -5" />
  <path d="M5 11l7 -2" />
  <path d="M16 21l-4 -7v-5l7 -4" />
</svg>`;